import Vue from 'vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import { Inertia } from '@inertiajs/inertia'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes, faBars, faUser, faUsers, faAngleRight, faAngleLeft, faAngleDoubleLeft, faAngleDoubleRight,
  faPowerOff, faExchangeAlt, faExclamationTriangle, faUserLock, faMedal, faInfoCircle, faLock, faHome, faEnvelopeOpenText, faArrowRight, faChevronRight
} from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faLinkedin, faGithub, faDiscord } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import VueAxios from 'vue-axios'
import moment from 'moment'
import { store } from './store'
import Skeleton from 'vue-loading-skeleton';
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueGtag from "vue-gtag";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
import VueCalendly from "vue-calendly";



InertiaProgress.init()
AOS.init({
  once: true,
  duration: 700,
  offset: 120,
  anchorPlacement: 'top-bottom',
  delay: 50,
});

Vue.prototype.$route = route
Vue.prototype.$products = {
  FACE: "face",
  WEB: "web",
  BIT: "bit",
  KYC: "kyc"
}
library.add(faTimes, faBars, faUser, faLinkedin, faUsers, faAngleRight, faCheckCircle, faAngleLeft,
  faAngleDoubleLeft, faAngleDoubleRight, faPowerOff, faExchangeAlt, faExclamationTriangle,
  faUserLock, faMedal, faInfoCircle, faLock, faHome, faGithub, faEnvelopeOpenText, faDiscord, faArrowRight, faChevronRight)


Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('multiselect', Multiselect)
Vue.component('loading', Loading)
Vue.use(VueAxios, axios)
Vue.use(Skeleton)

Vue.use(MonthPicker)
Vue.use(MonthPickerInput)

Vue.use(VueCalendly);

Vue.prototype.$primaryColor = "#624498";

Vue.use(VueGtag, {
  config: { id: process.env.MIX_GOOGLE_ANALYTICS_CLIENT_ID },
  globalObjectName: 'foo'
});

Inertia.on('start', (event) => {
  if (!navigator.onLine) {
    store.commit("showFlashMessage", {
      message: "Check your internet connection.",
      type: "danger",
    });
  }
})

Inertia.on('navigate', (event) => {
  if (window.Userled) {
    window.Userled("page");
  }
})

Sentry.init({
  Vue,
  dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    new BrowserTracing(/*{
     routingInstrumentation: Sentry.vueRouterInstrumentation(router), 
      tracingOrigins: ["localhost", "www.youverse.id", /^\//],
    }*/),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE),
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD MMM YYYY')
  }
  return value;
});

Vue.filter('price', function (value) {
  if (value) {
    return parseFloat(value).toLocaleString("pt-PT");
  }
  return value;
});

//Separate 3 digits number eg. 1 000 000
Vue.filter('numberFormat', function (value) {
  if (value) {
    return Number(value).toLocaleString("pt-PT");
  }
  return value;
});

/* Global functions */
Vue.mixin({
  methods: {
    showFullscreenLoader: function (message) {
      document.getElementById('fullscreenLoaderMessage').innerText = message;
      document.getElementById('fullscreenLoader').classList.remove('hidden');
    },
    hideFullscreenLoader: function () {
      document.getElementById('fullscreenLoaderMessage').innerText = '';
      document.getElementById('fullscreenLoader').classList.add('hidden');
    },
  },
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),

  setup({ el, app, props }) {
    new Vue({
      render: h => h(app, props),
      store: store,
    }).$mount(el)
  },
})

